import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import Hero from "../../components/Hero";
import Features from "../../components/Features";
import InstagramFeed from "../../components/InstagramFeed";
import Experiences from "../../components/Experiences";
import OwnerSection from "../../components/OwnerSection";
import FeaturedVideo from "../../components/FeaturedVideo";
import SeoAlternateLinks from "../../components/seo/SeoAlternateLinks";
import { buildAbsoluteUrl, derivePageMeta } from "../../utils/seo";

const HomePage = () => {
  const { t, i18n } = useTranslation();

  const meta = derivePageMeta({
    t,
    i18n,
    pageKey: "home",
    routeKey: "home",
    defaults: {
      ogImage: "/og/home.jpg",
    },
  });

  const ogImageUrl = buildAbsoluteUrl(meta.siteUrl, meta.ogImage);
  const twitterImageUrl = buildAbsoluteUrl(meta.siteUrl, meta.twitterImage);

  return (
    <>
      <Helmet>
        {meta.title && <title>{meta.title}</title>}
        {meta.description && <meta name="description" content={meta.description} />}
        {meta.keywords && <meta name="keywords" content={meta.keywords} />}
        <link rel="canonical" href={meta.canonicalUrl} />
        <meta property="og:title" content={meta.ogTitle} />
        <meta property="og:description" content={meta.ogDescription} />
        <meta property="og:image" content={ogImageUrl} />
        <meta property="og:url" content={meta.canonicalUrl} />
        <meta name="twitter:image" content={twitterImageUrl} />
        {meta.jsonLd && (
          <script type="application/ld+json">{JSON.stringify(meta.jsonLd)}</script>
        )}
      </Helmet>
      <SeoAlternateLinks
        routeKey="home"
        canonicalPath={meta.canonicalPath}
        siteUrl={meta.siteUrl}
      />
      <Hero />
      <FeaturedVideo />
      <Features />
      <InstagramFeed />
      <Experiences />
      <OwnerSection />
    </>
  );
};

export default HomePage;
